/** Unwrap the response envelopes used by the legacy and foundation clients. */
export function responseData<T>(input: unknown): T {
  let value = input;
  for (let depth = 0; depth < 5 && value && typeof value === 'object' && !Array.isArray(value) && 'data' in value; depth++) {
    value = (value as { data: unknown }).data;
  }
  return value as T;
}
export function responsePage<T>(input: unknown): { list: T[]; total: number } {
  let value = input;
  let total: number | undefined;
  for (let depth = 0; depth < 6; depth++) {
    if (Array.isArray(value)) return { list: value as T[], total: total ?? value.length };
    if (!value || typeof value !== 'object') break;
    const record = value as { data?: unknown; list?: unknown; tree?: unknown; members?: unknown; total?: number; count?: number };
    total = record.total ?? record.count ?? total;
    const list = record.list ?? record.tree ?? record.members;
    if (Array.isArray(list)) return { list: list as T[], total: total ?? list.length };
    value = record.data;
  }
  return { list: [], total: total ?? 0 };
}
export type CamelKey<S extends string> = S extends `${infer Head}_${infer Tail}` ? `${Head}${Capitalize<CamelKey<Tail>>}` : S;
export type WithCamelFields<T> = T & { [K in keyof T as K extends string ? CamelKey<K> : K]?: T[K] };
